import { getBaseActivityType } from './activities'

export const DISCIPLINE_COLORS = {
  swimming: '#2196F3',
  cycling: '#FF9800',
  running: '#4CAF50',
  strength: '#9C27B0',
  recovery: '#9E9E9E',
  mobility: '#879FAB',
  rest: '#9E9E9E',
  note: '#9E9E9E',
  event: '#2196F3',
  other: '#606060',
} as const

export type DisciplineType = keyof typeof DISCIPLINE_COLORS

export const getDisciplineColor = (discipline?: string): string => {
  const color = DISCIPLINE_COLORS[discipline as DisciplineType]
  if (color) return color

  const baseActivityType = getBaseActivityType(discipline || '')
  const baseActivityColor = DISCIPLINE_COLORS[baseActivityType as DisciplineType]
  return baseActivityColor || DISCIPLINE_COLORS.other
}
